import axios from "axios"
import { APIURL } from "../Constantes"
import { getCabecera } from "../utils/getCabecera"
import { getError } from "../utils/errors"

const urlLanding = "Landing"

//* Obtener tosdas las landing
//* GET /api/Landing/All
export const getLandingAll = async () => {
    return axios.get(`${APIURL}/${urlLanding}/All`,
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data
        }).catch((Error) => {
            //return Error.response.data;
            return []
        })
}
//* Obtener tosdas las landing habilitadas
//* GET /api/Landing/Available
export const getLandingAllHabilitadas = async () => {
    return axios.get(`${APIURL}/${urlLanding}/Available`,
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data
        }).catch((Error) => {
            //return Error.response.data;
            return []
        })
}
//* Obtener tosdas las landing asociadas a un paquete por clave paquete
//* GET /api/Landing/Package/{ClavePaquete}
export const getLandingPaquete = async ({ ClavePaquete }) => {
    return axios.get(`${APIURL}/${urlLanding}/Package/${ClavePaquete}`,
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data
        }).catch((Error) => {
            //return Error.response.data;
            return []
        })
}
//* Crear nueva landing page
//* POST /api/Landing
export const postLandingNew = async ({ Nombre, Descripcion, Enlace, Slug }) => {
    return axios.post(`${APIURL}/${urlLanding}`,
        {
            "Nombre": Nombre,
            "Descripcion": Descripcion,
            "Enlace": Enlace,
            "Slug": Slug
        },
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data
        }).catch((Error) => {
            return getError(Error)
        })
}
//* Actulizar nueva landing page
//* PUT /api/Landing/{IdLanding}
export const putLandingUpdate = async ({IdLanding, Nombre, Descripcion, Enlace, Slug, Estatus }) => {
    return axios.put(`${APIURL}/${urlLanding}/${IdLanding}`,
        {
            "Nombre": Nombre,
            "Descripcion": Descripcion,
            "Enlace": Enlace,
            "Slug": Slug,
            "Estatus": Estatus
        },
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data
        }).catch((Error) => {
            return getError(Error)
        })
}